import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthProvider} from "../../providers/auth/auth";
import {HomePage} from "../home/home";
import {ToastProvider} from "../../providers/toast/toast";
import {BarcodeScanner} from '@ionic-native/barcode-scanner';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  loginForm: FormGroup;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private auth: AuthProvider,
    private toast: ToastProvider,
    private barcodeScanner: BarcodeScanner,
  )
  {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ionViewDidLoad() {
    // this.loginByLoginToken('cf241dd5-d0d0-403a-85ee-cb646b065649');
  }

  scanQR() {
    this.barcodeScanner.scan().then(barcodeData => {
      this.loginByLoginToken(barcodeData.text);
    }).catch(err => {
      this.toast.error('Barcode kann nicht gelesen werden. Fehler: '+err);
    });
  }

  async loginByLoginToken(loginToken) {
    let authData = await this.auth.getTokenByLoginToken(loginToken);

    if (!authData) {
      this.toast.error('Fehler beim Login mit QR-Code.');
    } else {
      this.navCtrl.setRoot(HomePage)
    }
  }

  async loginSubmit() {
    let authData = await this.auth.getToken(this.loginForm.value);

    if (authData['error']) {
      let error = 'Es ist ein Fehler bei der Anmeldung aufgetreten!';

      switch (authData['error']) {
        case 'odoo_user_authentication_failed':
          error = 'User/Passwort nicht korrekt!';
          break;

        case 'no_rest_login_for_user':
          error = 'Sie sind für diese Applikation nicht berechtigt.'
      }

      this.toast.error(error);

    } else {
      this.navCtrl.setRoot(HomePage)
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts